import * as React from "react"

import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../cn"

const skeletonVariants = cva("block bg-coval-skeleton animate-skeleton-pulse", {
  variants: {
    variant: {
      default: "rounded-sm",
      circular: "rounded-full",
      text: "rounded-sm h-3.5 w-full",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export interface SkeletonProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(skeletonVariants({ variant, className }))}
        {...props}
        aria-hidden="true"
      />
    )
  },
)

Skeleton.displayName = "Skeleton"

export { Skeleton, skeletonVariants }
